import api from "../api";
import { saveAs } from 'file-saver'

export const ACTION_TYPES = {
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE',
    FETCH_DASHBOARD: 'FETCH_DASHBOARD',
    FETCH_OC_BY_STATUS: 'FETCH_OC_BY_STATUS',
    FETCH_ORDER_DETAIL: 'FETCH_ORDER_DETAIL',
    FETCH_PURCHASE_DOCUMENTS: 'FETCH_PURCHASE_DOCUMENTS',
    FETCH_PURCHASE_INVOICE_ERRORS: 'FETCH_PURCHASE_INVOICE_ERRORS',
    FETCH_TOKEN_NVP: 'FETCH_TOKEN_NVP',
    UPLOAD_EVIDENCE: 'UPLOAD_EVIDENCE',
    DELETE_EVIDENCE: 'DELETE_EVIDENCE',
    DELETE_INVOICE: 'DELETE_INVOICE',
    GET_INVOICE_TYPES: 'GET_INVOICE_TYPES',
    FETCH_STAGE_ID: 'FETCH_STAGE_ID'  //P2MSPFE-4420
}

export const fetch_Dashboard = (lang, token, supplierId, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().fetchDashboard(lang, token, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_DASHBOARD,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fecth_oc_by_status = (lang, token, supplierId, status, startDate, endDate, filter, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().fetchOCByStatus(lang, token, status, startDate, endDate, filter, supplierId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_OC_BY_STATUS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_order_detail = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().fetchOrderDetail(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_DETAIL,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}
export const save_delivery_dates = (lang, token, orderId, deliveryDates, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().saveDeliveryDates(lang, token, orderId, deliveryDates)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_DETAIL,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const upload_invoice = (lang, token, orderId, values, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().uploadInvoice(lang, token, orderId, values)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const validate_VIN = (lang, token, orderId, values, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().validateVIN(lang, token, orderId, values)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const upload_evidence = (lang, token, orderId, values, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().uploadEvidence(lang, token, orderId, values)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_DETAIL,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_documents = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().fetchOrderDocuments(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_PURCHASE_DOCUMENTS,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}
export const getInvoiceTypeOptions = (lang, token, orderId, remainingAmount, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().getInvoiceTypeOptions(lang, token, orderId, remainingAmount)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.GET_INVOICE_TYPES,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
};
export const fetch_invoice_errors = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().fetchInvoiceErrors(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_PURCHASE_INVOICE_ERRORS,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const download_document = (lang, token, onError, documentId, orderId, documentType, onSuccess) => dispatch => {
    api.PurchaseOrders().downloadDocument(lang, token, documentId, orderId, documentType)
        .then(response => {
            const fileName1 = response.headers['content-disposition'].split(';')[1].split('=')[1]
            const contentType = response.headers['content-type']
            var blob = new Blob([response.data], { type: contentType })
            saveAs(blob, fileName1.replace(/['"]+/g, ''))
            onSuccess(response)
        })
        .catch((err) => {
            onError(err)
        })
}

export const download_evidence = (lang, token, onError, documentId, orderId, onSuccess) => dispatch => {
    api.PurchaseOrders().downloadEvidence(lang, token, documentId, orderId)
        .then(response => {
            const fileName1 = response.headers['content-disposition'].split(';')[1].split('=')[1]
            const contentType = response.headers['content-type']
            var blob = new Blob([response.data], { type: contentType })
            saveAs(blob, fileName1.replace(/['"]+/g, ''))
            onSuccess(response)
        })
        .catch((err) => {
            onError(err)
        })
}

export const delete_evidence = (lang, token, evidenceId, orderId, nameInContainer, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().DeleteEvidence(lang, token, evidenceId, orderId, nameInContainer)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.DELETE_EVIDENCE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_invoice = (lang, token, onError, invoiceId, orderId, onSuccess) => dispatch => {
    api.PurchaseOrders().DeleteInvoice(lang, token, invoiceId, orderId)
        .then(response => {
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_right = (lang, token, onError, rightId, orderId, onSuccess) => dispatch => {
    api.PurchaseOrders().DeleteRight(lang, token, rightId, orderId)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const download_document_AnnexB = (lang, token, folio, orderId, onError, onSuccessDownload) => dispatch => {
    api.PurchaseOrders().downloadDocumentAnnexB(lang, token, folio, orderId)
        .then(response => {
            const data = "data:application/pdf;base64," + response.data.content
            saveAs(data, response.data.entryName)
            onSuccessDownload(response)
        })
        .catch((err) => {
            onError(err)
        })
}

export const download_order_details = (lang, token, orderId, onError, onSuccessDownload) => dispatch => {
    api.PurchaseOrders().downloadOrderDetails(lang, token, orderId)
        .then(response => {
            const data = "data:application/pdf;base64," + response.data.fileBase64
            saveAs(data, response.data.fileName)
            onSuccessDownload(response)
        })
        .catch((err) => {
            onError(err)
        })
}

export const upload_annexB = (lang, token, orderId, values, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().uploadAnnexB(lang, token, orderId, values)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ORDER_DETAIL,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const find_Quadrant = (lang, token, supplierId, orderNumber, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().findQuadrant(lang, token, supplierId, orderNumber)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const test_Connect_Nvp = (token, value) => dispatch => {
    api.PurchaseOrders().testConnectionNvp(token, { datos: value })
        .then(response => {
            console.log(response)
        })
        .catch(err => console.log(err))
}
//P2MSPFE-4420
export const fetch_StageId = (lang, token, nvpQuoteMultipleUnits, onError, onSuccess) => dispatch => {
    api.PurchaseOrders().fetchStageId(lang, token, nvpQuoteMultipleUnits)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_STAGE_ID,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}
//End P2MSPFE-4420